'use client';

import { useContext } from 'react';

import { InventoryItem } from '@/components/Inventory/InventoryItem';
import { inventoryItemMinWidth, maxSlidesInInventorySlider } from '@/constants/inventory';
import { LayoutContext } from '@/contexts/LayoutContext';
import { getDefaultSort } from '@/tools/inventory';
import { LaMesaRecVanLogo } from '@lamesarv-sdk/components';
import { SliderInventory } from '@lamesarv-sdk/inventory';

interface PdpSimilarRVsSliderProps {
  filters: string;
}

export const PdpSimilarRVsSlider = ({ filters }: PdpSimilarRVsSliderProps) => {
  const { context } = useContext(LayoutContext);

  if (context.isGeoLocationLoading)
    return (
      <div className="py-12 flex items-center justify-center">
        <LaMesaRecVanLogo className="h-20 animate-pulse" />
      </div>
    );

  return (
    <SliderInventory
      filters={filters}
      limit={10}
      sort={getDefaultSort(context)}
      geoLocation={context.geoLocation}
      CustomInventoryItem={InventoryItem}
      minSlideWidth={inventoryItemMinWidth}
      maxSlides={maxSlidesInInventorySlider}
    />
  );
};
